import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Modal, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../styles/Dashboard.css";
import TableComponent from "../components/TableComponent/TableComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  handleGetTenantAdminsData,
  handleGetTenantData,
  handleGetTenantManagersData,
} from "../store/actions/tenantsActions";
import { handleCreateUser } from "../store/actions/userActions";
import Cookies from "js-cookie";
import { ICONS } from "../constants/constants";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Loader from "../assets/images/loader.gif";

const Managers = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { tenantData, tenantManagersData, isLoading } = useSelector(
    (state) => state.tenants
  );

  const tenantName = tenantData?.data?.tenant?.name;
  const tenantCompanies = tenantData?.data?.tenant?.companies || [];

  const userrole = user?.role;
  const tenantId = userrole === "superadmin" ? user?.tenant?.id : null;

  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    companyId: tenantCompanies?.[0]?.id || "",
    address: "",
    cnic: "",
  });
  const [companies, setCompanies] = useState(tenantCompanies || []);

  useEffect(() => {
    if (tenantId) {
      dispatch(handleGetTenantAdminsData(tenantId));
      dispatch(handleGetTenantManagersData(tenantId));
      dispatch(handleGetTenantData(tenantId));
    }
  }, [dispatch, tenantId]);

  useEffect(() => {
    // update default company when tenantData loads
    setForm((f) => ({
      ...f,
      companyId: tenantCompanies?.[0]?.id || f.companyId,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantCompanies?.length]);

  // Fetch global companies list via company API (no id required)
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const BASE_URI = process.env.REACT_APP_BASE_URI;
        const res = await fetch(`${BASE_URI}/company`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("auth-token")}`,
          },
        });
        if (!res.ok) return;
        const data = await res.json();
        // Expecting data.data.companies or data.data.company list
        const list = data?.data?.companies || data?.data?.company || data?.data || [];
        setCompanies(list);
        // If no company selected in form, pick first
        setForm((f) => ({ ...f, companyId: f.companyId || list?.[0]?.id || "" }));
      } catch (e) {
        // ignore fetch errors silently
      }
    };
    fetchCompanies();
  }, []);

  const managers = tenantManagersData?.data?.managers?.filter((a) => a.role === "manager");

  const data = managers?.map((m) => ({
    Tenant: tenantName || "N/A",
    Name: m?.name,
    Email: m?.email,
    Company: m?.company?.name || "N/A",
    Address: m?.address || "N/A",
    CNIC: m?.cnic || "N/A",
    Status: m?.account_status || "N/A",
    Actions: (
      <>
        <Link to={`/manager/${m.id}`} state={{ manager: m }}>
          <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
        </Link>
        <img
          src={ICONS.downloadIcon}
          alt="Download"
          className="cross-icon"
          onClick={() => {
            const doc = new jsPDF();
          
            doc.setFontSize(16);
            doc.text("Manager Details", 14, 15);
          
            doc.setFontSize(12);
          
            doc.autoTable({
              startY: 25,
              head: [["Field", "Information"]],
              body: [
                ["Tenant", tenantName || "N/A"],
                ["Name", m?.name || "N/A"],
                ["Email", m?.email || "N/A"],
                ["Company", m?.company?.name || "N/A"],
                ["Address", m?.address || "N/A"],
                ["CNIC", m?.cnic || "N/A"],
                ["Status", m?.account_status || "N/A"],
                ["Manager ID", m?.id || "N/A"],
                ["Generated On", new Date().toLocaleDateString() || "N/A"],
              ],
            });
          
            doc.save(`Manager_${m.name}.pdf`);
          }}
          
        />
      </>
    ),
  }));

  const columns = [
    "Tenant",
    "Name",
    "Email",
    "Company",
    "Address",
    "CNIC",
    "Status",
    "Actions",
  ];

  const handleSave = async () => {
    // create manager via createUser API (role: manager)
    const payload = {
      ...form,
      role: "manager",
      tenantId: tenantId, // include tenantId in create payload
    };
    const res = await handleCreateUser(payload, dispatch);
    if (res) {
      setShowModal(false);
      // refresh list
      if (tenantId) dispatch(handleGetTenantAdminsData(tenantId));
    }
  };

  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  return (
    <Container>
      <Row>
      <Col lg={12} className="component-container mb-2">
      <Row className="mb-3 align-items-center">
        <Col xs={9}>
          <h3>Managers</h3>
        </Col>
        <Col xs={3} className="text-center">
          <Button className="addButton" onClick={() => setShowModal(true)}>
            {ICONS?.addPlusIcon && <img src={ICONS.addPlusIcon} className="faPlusIcon" alt="Add" />}
            Add New Manager
          </Button>
        </Col>
        
      </Row>

      {(!managers || managers.length === 0) ? (
        <Row>
          <Col>
            <div className="text-center py-5">No manager available</div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col>
            <TableComponent
              columns={columns}
              data={data}
              // title="Managers"
              showSearchBar={true}
              showFilter={false}
              showTabs={false}
              showColors={false}
            />
          </Col>
        </Row>
      )}

      <Modal className="modal-container custom-modal-width AddModalSuper" show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton className="AddModalHeader border-0">
          <Modal.Title className="AddNewAdmin">
            Add New Manager
            <p className="sub-title mt-2 ">Enter Details for new manager</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-1">
          <Form>
            <Row className="adminFormOutliner">
              <Col md={6}>
                <Form.Group controlId="name" className="my-1">
                  <Form.Label className="auth-form-label">Name<span>*</span></Form.Label>
                  <Form.Control type="text" placeholder="Enter name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="address" className="my-1">
                  <Form.Label className="auth-form-label">Address<span>*</span></Form.Label>
                  <Form.Control type="text" placeholder="Enter address" value={form.address} onChange={(e)=>setForm({...form,address:e.target.value})} />
                </Form.Group>
              </Col>
            </Row>

            <Row className="adminFormOutliner">
              <Col md={6}>
                <Form.Group controlId="company" className="my-1">
                  <Form.Label className="auth-form-label">Company<span>*</span></Form.Label>
                  <Form.Select value={form.companyId} onChange={(e)=>setForm({...form,companyId:e.target.value})}>
                    <option value="">Select company</option>
                    {companies?.map((c)=>(
                      <option key={c.id} value={c.id}>{c.name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="cnic" className="my-1">
                  <Form.Label className="auth-form-label">CNIC<span>*</span></Form.Label>
                  <Form.Control type="text" placeholder="Enter Manager's CNIC (e.g. 12345-6789012-3)" value={form.cnic} onChange={(e)=>setForm({...form,cnic:e.target.value.replace(/[^0-9-]/g,'')})} />
                </Form.Group>
              </Col>
            </Row>

            <Row className="adminFormOutliner">
              <Col md={6}>
                <Form.Group controlId="email" className="my-1">
                  <Form.Label className="auth-form-label">Email Address<span>*</span></Form.Label>
                  <Form.Control type="email" placeholder="Manager's email address here" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="password" className="my-1">
                  <Form.Label className="auth-form-label">Password<span>*</span></Form.Label>
                  <Form.Control type="password" placeholder="Enter Manager's password" value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})} />
                </Form.Group>
              </Col>
            </Row>

          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <div className="w-100 text-center">
            <Button  type="submit" className="button" onClick={handleSave}>Add New Manager</Button>
          </div>
        </Modal.Footer>
      </Modal>
      </Col>
      </Row>
    </Container>
  );
};

export default Managers;

